import React, { useState } from 'react';
import { history } from '../../../../../_helpers/history';
import { formService as service } from '../../../../../_services/form.service';
import { Alert, Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

function CancelAction({ form }) {
  const [show, setShow] = useState(false);
  const [canceling, setCanceling] = useState(false);
  const handleClose = () => { setShow(false); }
  const handleShow = () => { setShow(true); }

  const [successMsg, setSuccessMsg] = useState('');
  const [failedMsg, setFailedMsg] = useState('');

  return <>
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>Cancel</Tooltip>}
    >
      <button
        title="Cancel"
        onClick={handleShow}
        className="btn btn-outline-primary btn-sm">
        <i className="fas fa-calendar-times" aria-hidden="true"></i>
      </button>
    </OverlayTrigger>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Cancel Form</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {successMsg && <div className="alert alert-success">{successMsg}</div>}
        {failedMsg && <div className="alert alert-danger">{failedMsg}</div>}

        <Alert variant='primary'>
          Are you sure you want to cancel this form? The patient will not be able to complete this form if it is canceled.
        </Alert>

      </Modal.Body>

      <Modal.Footer>
        <Button onClick={() => {
          setCanceling(true);
          setSuccessMsg('');
          setFailedMsg('');

          service.cancelForm(form)
            .then(() => {
              setCanceling(false);
              setSuccessMsg('Form has been canceled.');

              setTimeout(() => {
                handleClose();
                history.go(0);
              }, 1500);
            })
            .catch((error) => {
              setCanceling(false);

              setFailedMsg('Could not cancel this form. Please try again later.');
            });
        }}
          disabled={canceling}
          variant="primary"
        >
          {canceling ? 'Canceling...' : 'Yes'}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default CancelAction;